import Device from "../models/Device";
import { ValueLevels } from "../models/KnxInstanceData";

function checkSimilarity(a: any, b: any): boolean {
  if (!a?.typeId || !b?.typeId) {
    return false;
  }

  if (!a.textEN || !b.textEN) {
    return false;
  }

  if (a.textEN == b.textEN) {
    return true;
  }

  //   Erklärung des regEx:
  // ^
  // → Start des Strings

  // (.*?) → Gruppe 1 → match[1]
  // → alles vom Anfang bis kurz vor den optionalen Leerzeichen/Doppelpunkt
  // → .*? bedeutet: so wenig wie möglich (non-greedy), damit es nicht zu viel „verschlingt“

  // (?:\s+|:)? → non-capturing group → landet in keinem match[n]
  // → optional (ein oder mehrere Leerzeichen ODER ein Doppelpunkt)
  // → ?: bedeutet: nur gruppieren, nicht als eigenes Match speichern

  // ([a-zA-Z]|\d+|\d+/\d+) → Gruppe 2 → match[2]
  // → der letzte Ausdruck am Ende:

  // ein einzelner Buchstabe

  // eine oder mehrere Ziffern

  // zwei Zahlen mit Slash dazwischen

  // $
  // → Ende des Strings

  const regEx = /^(.*?)(?:\s+|:)?([a-zA-Z]|\d+|\d+\/\d+)$/;

  const textA = a.textEN;
  const textB = b.textEN;

  const matchA = textA.match(regEx);
  const matchB = textB.match(regEx);

  if (matchA && matchB) {
    const firstPartA = matchA[1].trim();
    const firstPartB = matchB[1].trim();

    const typeA = matchA[2].trim();
    const typeB = matchB[2].trim();

    if (firstPartA === firstPartB) {
      //
      //
      console.log("found similar property1: " + textA + " - " + textB);
      console.log("found similar property2: " + firstPartA + " - " + firstPartB);
      return true;
    } else {
      console.log("NOT found similar property2: " + firstPartA + " - " + firstPartB);
      return false;
    }
  }

  return false;
}

export function findSimilarProperties(
  device: Device,
  id: string,
  instanceId: string | undefined,
): Array<{ id: string; instanceId: string }> {
  //
  // find all properties with the same name
  //
  //
  // Device is not using Modules at all
  //
  // Search all Property with the same text and the same typeId
  //
  const edMain = device.knxInstanceData.getExtendedData(id, instanceId);

  const allPropertyIds = new Array<{ id: string; instanceId: string }>();

  const allModuleIds = device.knxInstanceData.allModuleIds(); // "" for "main" is already included

  allModuleIds.forEach((instanceId2) => {
    device.knxInstanceData.allPropertyIds(instanceId2).forEach((propetyId2) => {
      const v = device.knxInstanceData.getValue(propetyId2, instanceId2);
      if (v != undefined) {
        //
        // MWE 7.5.2025
        // "v" wird undefind sein, wenn die Property zur Zeit nicht referenziert wird,
        // dh. im einfachsten Fall ausgeblendet ist aufgrund einer "höheren" Bedingung.
        // zB weil der ChannelType von "switch" auf "staicase light" geändert wurde oder ähnliches
        //
        allPropertyIds.push({ id: propetyId2, instanceId: instanceId2 });
      }
    });
  });

  const res = new Array<{ id: string; instanceId: string }>();

  allPropertyIds.forEach((property) => {
    const ed = device.knxInstanceData.getExtendedData(property.id, property.instanceId);
    //
    // Mindestvoraussetztung ist der gleiche Typ
    //
    if (edMain?.info && ed?.info && checkSimilarity(edMain.info, ed.info)) {
      res.push(property);
    }
  });

  return res;
}

export function setValueForSimilarProperties(
  device: Device,
  similarProperties: Array<{ id: string; instanceId: string }>,
  newValue: string,
) {
  for (let similarPropertiy of similarProperties) {
    /////////////////////////////////
    // handle undo
    let lastValue = device.knxInstanceData.getValue(similarPropertiy.id, similarPropertiy.instanceId);
    if (lastValue != undefined) {
      device.knxInstanceData.setValue(
        ValueLevels.interactive,
        newValue,
        similarPropertiy.id,
        similarPropertiy.instanceId,
        "",
      );
    }
  }
}
